import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { ThemeProvider } from './context/ThemeContext';
import Home from './components/Home';
import CanvasPage from './components/CanvasPage';
import './index.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/canvas" element={<CanvasPage />} />
          </Routes>
          <Analytics />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
